module.exports = __webpack_public_path__ + "static/media/0224_IMG_LES_MURS_METRO_DIAMANTO_MAT_TORBA_CHEVRON.1ae24af2.png";